import React from 'react'
import styled from '@emotion/styled'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'
import { keyframes } from '@emotion/react'

export const SearchCardSkeleton = (): JSX.Element => (
	<SkeletonWrapper>
		<SkeletonTop>
			<SkeletonImage className="same"></SkeletonImage>
			<SkeletonTitleWrapper>
				<SkeletonTitle className="same"></SkeletonTitle>
				<SkeletonTitleShort className="same"></SkeletonTitleShort>
			</SkeletonTitleWrapper>
		</SkeletonTop>
		<SkeletonCenter>
			<SkeletonItem className="same"></SkeletonItem>
			<SkeletonItem className="same"></SkeletonItem>
			<SkeletonItem className="same"></SkeletonItem>
			<SkeletonItem className="same"></SkeletonItem>
		</SkeletonCenter>
		<SkeletonButton className="same"></SkeletonButton>
	</SkeletonWrapper>
)

const load = keyframes`
from {
	left: -150px;
}
to {
	left: 100%;
}
`

const SkeletonWrapper = styled.div`
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: ${COLORS.WHITE};
	padding: 16px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	.button {
		width: 100%;
	}
	.image {
		width: 100%;
		height: 60px;
	}
	.same {
		border-radius: 4px;
		position: relative;
		overflow: hidden;
		background-image: linear-gradient(to right, #e6e6e6, #e0e0e0);
		:before {
			content: '';
			display: block;
			position: absolute;
			left: -150px;
			top: 0;
			height: 100%;
			width: 150px;
			background: linear-gradient(to right, transparent 0%, ${COLORS.SMOKE_WHITE} 50%, transparent 100%);
			animation: ${load} 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
		}
	}
`

const SkeletonTop = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
`

const SkeletonTitleWrapper = styled.div`
	padding-left: 16px;
	width: 100%;
	display: flex;
	flex-direction: column;
`

const SkeletonImage = styled.div`
	width: 52px;
	height: 52px;
	min-width: 52px;
	background-color: ${COLORS.SMOKE_WHITE};
`

const SkeletonButton = styled.div`
	width: 100%;
	height: 50px;
	width: 80%;
	background-color: ${COLORS.SMOKE_WHITE};
	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
	}
`

const SkeletonCenter = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	> div:nth-last-of-type(1) {
		width: 20px;
	}
	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		flex-wrap: wrap;
		> div:nth-last-of-type(1) {
			width: 46%;
		}
	}
`

const SkeletonItem = styled.div`
	width: 22%;
	height: 45px;
	margin-bottom: 31px;
	background-color: ${COLORS.SMOKE_WHITE};
	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 46%;
		height: 45px;
	}
`

const SkeletonTitle = styled.div`
	width: 100%;
	height: 20px;
	margin-bottom: 8px;
	background-color: ${COLORS.SMOKE_WHITE};
`

const SkeletonTitleShort = styled.div`
	width: 70%;
	height: 20px;
	background-color: ${COLORS.SMOKE_WHITE};
`
